<template>
  <div class="layout">
    <aside class="sidebar-col">
      <Sidebar />
    </aside>
    <main class="main-content">
      <header class="top-header">
        <div class="header-left">
          <h2 class="page-title">{{ $route.meta.title || 'داشبورد والدین' }}</h2>
          <span class="breadcrumb" v-if="$route.name !== 'Dashboard'"> / {{ $route.name }}</span>
        </div>
        <div class="user-profile">
          <span class="user-name">والد گرامی</span>
          <div class="avatar-circle">
            <img src="https://api.dicebear.com/7.x/thumbs/svg?seed=Parent" alt="avatar" />
          </div>
        </div>
      </header>
      <div class="content-body">
        <router-view v-slot="{ Component }">
          <transition name="slide-fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </main>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
export default { name: 'DashboardLayout', components: { Sidebar } }
</script>

<style scoped>
.layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  height: 100vh;
  overflow: hidden; /* Prevent body scroll */
  background: #f8fafc;
  font-family: 'Vazirmatn', sans-serif;
}

.sidebar-col {
  background: #fff;
  border-left: 1px solid #edf2f7;
  height: 100%;
  overflow-y: auto;
  z-index: 50;
  box-shadow: 4px 0 24px rgba(0,0,0,0.02);
}

.main-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  position: relative;
}

.top-header {
  height: 72px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  position: sticky;
  top: 0;
  z-index: 40;
  border-bottom: 1px solid #f1f5f9;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.breadcrumb {
  color: #94a3b8;
  font-size: 14px;
  margin-right: 8px;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s;
}
.avatar-circle:hover { transform: scale(1.05); }
.avatar-circle img { width: 100%; height: 100%; object-fit: cover; }

.content-body {
  padding: 32px 40px;
  flex: 1;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from {
  transform: translateY(20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

@media (max-width: 1024px) {
  .layout { grid-template-columns: 80px 1fr; }
}
@media (max-width: 768px) {
  .layout { grid-template-columns: 1fr; }
  .sidebar-col { display: none; }
  .top-header { padding: 0 20px; }
  .content-body { padding: 20px; }
}
</style>
